export default "__VITE_ASSET__66a70783__"